import { persistStore } from 'redux-persist'
import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import reducer from '../reducers'

export const store = createStore(reducer, applyMiddleware(thunk))

export const persistor = persistStore(store)



// WEBPACK FOOTER //
// ./src/store/index.js